<template>
  <div class="footer container">
 
   <div class="footer_container">
    
  
    <div class="page_width grid grid_xs_gap grid_gap_none footer_info" >
      <div class="footer_thumb grid_md_3 grid_xs_12 grid_sm_12">
        <div class="footer_logo">
          <img src="../assets/image/logo.png" alt="">
        </div>
        <!-- <div class="bg_btn" style="display: inline-block; margin-top:20px;" >
          <div class="" style="padding:10px 20px;"><router-link to="/contactus">Contact Us</router-link></div>
        </div> -->
     </div>
      <div class="footer_thumb grid_md_3 grid_xs_12 grid_sm_12 ">
        <!-- <div class="thumb_title">Usefull Links</div> -->
        <div class="themb_info"><router-link to="/index">Home</router-link></div>
        <div class="themb_info"><router-link to="/games">Games</router-link></div>
        <div class="themb_info"><router-link to="/aboutus">About Us</router-link></div>
        <div class="themb_info"><router-link to="/privacypolicy">Privacy Policy</router-link></div>
        <div class="themb_info"><router-link to="/terms">Terms of Use</router-link></div>
        <div class="themb_info"><router-link to="/contactus">Contact Us</router-link></div>
         <!-- <div class="themb_info"><router-link to="/join">Join Us</router-link></div> -->
        
        
     </div>
    <!-- <div class="footer_thumb grid_md_3 grid_xs_12 grid_sm_12">
      <div class="thumb_title">More</div>
      <div class="themb_info"><router-link to="/privacypolicy">Privacy Policy</router-link></div>
      <div class="themb_info"><router-link to="/terms">Terms of Use</router-link></div>
    </div> -->
    <div class="footer_thumb grid_md_6 grid_xs_12 grid_sm_12">
      <div class="thumb_title">Get in Touch</div>
    
      <div class="themb_info">
        <!-- <p style="font-weight:800;">Address：</p> -->
        14509 Bowcreek Ln Chino Hills, CA 91709 United States</div>
      <div class="themb_info">
        <!-- <p style="font-weight:800;">Emali：</p> -->
        support@futurelastertech.com</div>
    </div>
    
   
     <!-- <div class="footer_thumb grid_md_4 grid_xs_12 grid_sm_12">
        <div class="thumb_title">Follow With Us:</div>
        <div class="themb_info flex">
          <div class="info_fab"><a href="https://www.facebook.com/"><img src="../assets/image/facebook.svg" alt=""></a></div>
          <div class="info_fab"><a href="https://www.twitter.com/"><img src="../assets/image/twiter.svg" alt=""></a></div>
          <div class="info_fab"><a href="https://www.linkedin.com/"><img src="../assets/image/linkedin.svg" alt=""></a></div>
          <div class="info_fab"><a href="https://www.instagram.com/"><img src="../assets/image/ins.svg" alt=""></a></div>
        </div>
        
     </div> -->
    </div>
    <div class="page_width">
      <div class="footer_copyright ">© Copyright FUTURE LASER TECH LLC All rights reserved</div>
    </div>
   </div>
    
    
  </div>
</template>

<script>
export default {
  name:'ASTRfooter',
  data(){
    return{}
    
  },
  methods:{
    toPage(path){
      this.$router.push(path)
    }
  },
  computed:{
    menuList(){return this.$store.state.menuList}
  },
}
</script>

<style lang='scss' scoped>
.footer {
  background: #030E22;


  // background-image:url(../../public/bg/footer.png);
  // background-position: center center;
  // background-repeat: no-repeat;
  // background-size: cover;
  
  .footer_container{
    padding-top:20px;
    padding-bottom:30px;
    .footer_logo{
      // clip-path: polygon(0 0, 100% 0, calc(100% - 60px) 100%, 60px 100%);
      // padding: 12px 170px;
      display: block;
      // margin:0 auto;
      >img{
       width: 150px;
      }
    }
    .footer_menu{
      padding:40px 0;
      color:$theme_color1;
      .footer_link{
        padding:10px;
        transition: all 0.35s ease;
        &:hover{
          color:$theme_color3;
        }
      }
    }
    .footer_info{
      // border-top:4px solid $theme_bg;
      // border-bottom:4px solid $theme_bg;
     
    }
  }
 
  .footer_container {
   
    .footer_thumb{
      padding-top:20px;
      text-align: left;
      color:$theme_color1;
      .footer_logo{
        width: 150px;
      }
      .footer_join{
        margin-top:40px;
        font-size: 18px;
        text-align: left;
      }
      .footer_link{
        text-align: left;
        padding:6px; 
        
      }
      .thumb_title{
        font-size: 20px;
        margin-bottom:10px;
      }
      .themb_info{
        // margin-top:10px;
        font-size: 14px;
        color:$theme_color1;
        font-family: PingFang SC, PingFang SC;
        line-height: 1.4;
        margin-bottom:10px;
        // padding:0 15px;
        .info_fab{
          padding-right:10px;
          
        }
      }
    }
   
  }
  .footer_copyright{
    // clip-path: polygon(60px 0%, calc(100% - 60px) 0%, 100% 50%, 100% 100%, 0 100%, 0% 50%);
    // padding: 45px 75px;
    font-size: 14px;
    color:$theme_color1;
    font-family: Arial, Helvetica, sans-serif;
    background:$theme_bg;
    display: inline-block;
    position: relative;
    margin-top:30px;
  }
}
</style>